<template>
  <div class="container">
    <dingbu></dingbu>
    <div class="home_content">
      <div
        class="bg_color"
        :style="{
          background:
            'url(' +
            require('../../assets/img/' + bei_ing) +
            ') no-repeat center center',
          'background-size': '100% 100%',
        }"
      >
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi2" @click="kxuexis">学习中心</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi2" @click="kaoshi">考试记录</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">查看证书</span>
            </div>
          </div>
          <div class="certi">
            <img :src="zheng.qrcodeurl" alt="" class="zheng-img" />
            <div class="kaoshi-chengji">
              <span>您的考试成绩为：</span>
              <span>{{ zheng.score }}分，考试通过</span>
            </div>
            <div class="xiazai-zhengshu" @click="xiazai">下载证书</div>
            <div class="fan-hui" @click="fanghui">返回</div>
          </div>
        </div>
        <dibu></dibu>
        <daohan></daohan>
      </div>
    </div>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,
    dingbu,
  },
  data() {
    return {
      id: "",
      zheng: [],
      file: '',
      order: '',
      bei_ing: this.Public.bei_ing,
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.order = this.$route.query.order;
    console.log(this.order)
    console.log(this.id)
    this.getzheng()
  },
  methods: {
    //下载
    xiazai() {
      window.location.href = this.file;
    },
    //点击返回上一页
    fanghui() {
      this.$router.push({ path: "/profile", query: { id: this.order } });
    },
    kaoshi() {
      this.$router.push({ path: "/profile", query: { id: this.order } });
    },
    kxuexis() {
      this.$router.push({ path: "/learn" });
    },
    //证书接口
    getzheng() {
      let that = this;
      var url = "user/certificate";
      let param = {
        id: this.id,
      };
      this.post(url, param)
        .then((res) => {
          console.log(res);
          this.zheng = res.data
          this.file = res.data.qrcodeurl
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import "../../css/certificate.css";
</style>